import {
  HttpClient,
  HttpErrorResponse,
  HttpParams,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastService } from '@techspert-io/user-alerts';
import { catchError, Observable, tap } from 'rxjs';
import {
  IOpportunitySegmentData,
  IOpportunitySegmentUpdateRequest,
  IStatEnrichedOpportunitySegmentData,
} from '../models/opportunity-segments.models';

@Injectable({
  providedIn: 'root',
})
export class OpportunitySegmentsService {
  private readonly baseUrl = '/opportunity-segments';

  constructor(
    private http: HttpClient,
    private toastService: ToastService
  ) {}

  get(opportunitySegmentId: string): Observable<IOpportunitySegmentData> {
    return this.http.get<IOpportunitySegmentData>(
      `${this.baseUrl}/${opportunitySegmentId}`
    );
  }

  queryByOpportunityId(
    opportunityId: string
  ): Observable<IOpportunitySegmentData[]> {
    return this.http.get<IOpportunitySegmentData[]>(`${this.baseUrl}/query`, {
      params: new HttpParams({ fromObject: { opportunityId } }),
    });
  }

  update(
    segment: IOpportunitySegmentUpdateRequest
  ): Observable<IOpportunitySegmentData> {
    return this.http
      .patch<IOpportunitySegmentData>(
        `${this.baseUrl}/${segment.opportunitySegmentId}`,
        segment
      )
      .pipe(
        tap((res) =>
          this.toastService.sendMessage(
            `Updated "${res.geography} ${res.segment}"`,
            'success'
          )
        ),
        catchError((err) => {
          if (err instanceof HttpErrorResponse) {
            this.toastService.sendMessage(err.error.message, 'error');
            throw new Error(err.error);
          }
          throw new Error('Unknown error');
        })
      );
  }

  queryStats(opportunityId: string) {
    return this.http.get<IStatEnrichedOpportunitySegmentData[]>(
      `${this.baseUrl}/query-stats`,
      {
        params: new HttpParams({ fromObject: { opportunityId } }),
      }
    );
  }
}
